import { RiArrowLeftSLine } from '@remixicon/react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import walletImage from '../../../assets/male-soccer-player-with-ball-grass-field.png';
import Footer from '../../../components/Footer';
import { Deposit2 } from '../../../components/Icons/Deposit2';
import { FutProIcon } from '../../../components/Icons/FutProIcon';
import { PickProIcon } from '../../../components/Icons/PickProIcon';
import { Withdraw2 } from '../../../components/Icons/Withdraw2';
import { Layout } from '../../../components/layout';
import { TabsButton } from '../../../components/TabsButton';
import {
	choosePlatform,
	CurrencyFormatter,
	showWalletAndBalance,
} from '../../../helpers/utils';
import { useBalanceStore } from '../../../store/balance';
import { WalletBonus } from './WalletBonus';
import { WalletReal } from './WalletReal';

export const Wallet = () => {
	const currentBalance = useBalanceStore((state) => state.balance);
	const currentBalanceReal = useBalanceStore((state) => state.balanceReal);
	const currentBalanceBonus = useBalanceStore((state) => state.balanceBonus);
	const navigate = useNavigate();
	const [tabs, setTabs] = useState('Disponível');

	const tabsData = [
		{
			title: 'Disponível',
			renderPage: () => <WalletReal tabsSelect={tabs} />,
		},
		{
			title: 'Bônus',
			renderPage: () => <WalletBonus tabsSelect={tabs} />,
		},
	];

	const onChangeTabs = (tab: string) => {
		if (tab === tabs) {
			return;
		}
		setTabs(tab);
	};

	return (
		<Layout>
			<div className="items-center flex-row flex justify-between py-6 px-3.5 lg:max-w-screen-xl lg:mx-auto lg:pt-4">
				<a
					onClick={() => {
						navigate('/profile');
					}}
					className="lg:hidden cursor-pointer"
				>
					<RiArrowLeftSLine />
				</a>
				<p className="text-xl font-semibold text-custom-gray1 font-bahnschrift">
					Minha Carteira
				</p>
				<div></div>
			</div>

			<div className="flex flex-col w-full px-3 lg:max-w-screen-xl lg:mx-auto lg:pt-4">
				<div
					className="relative w-full h-44 bg-cover rounded-lg shadow bg-custom-black"
					style={{
						backgroundImage: `url(${walletImage})`,
						mixBlendMode: 'darken',
					}}
				>
					<div className="absolute inset-0 flex flex-col items-center justify-center bg-custom-black bg-opacity-80 rounded-lg ">
						<div className="flex flex-col items-center">
							<p className="text-base text-custom-white text-lef lg:text-xl font-bahnschrift">
								Saldo Total
							</p>
							<p className="text-4xl font-bold text-custom-white text-left font-bahnschrift flex gap-1 items-center">
								{showWalletAndBalance() ? (
									'R$ '
								) : choosePlatform() ? (
									<PickProIcon
										style="w-7 h-7"
										color="#ffffff"
									/>
								) : (
									<FutProIcon
										style="w-7 h-7"
										color="#ffffff"
									/>
								)}
								{CurrencyFormatter(Number(currentBalance))}
							</p>
						</div>
						<div className="flex w-full justify-between px-14 flex-row gap-3">
							<div className="text-custom-white text-left text-xs font-bahnschrift">
								Disponível
								<p className="text-xl font-bold text-custom-white text-left font-bahnschrift flex gap-1 items-center">
									{showWalletAndBalance() ? (
										'R$ '
									) : choosePlatform() ? (
										<PickProIcon
											style="w-7 h-7"
											color="#ffffff"
										/>
									) : (
										<FutProIcon
											style="w-7 h-7"
											color="#ffffff"
										/>
									)}
									{CurrencyFormatter(
										Number(currentBalanceReal)
									)}
								</p>
							</div>
							<div className="text-custom-white text-left text-xs font-bahnschrift">
								Em Bônus
								<p className="text-xl font-bold text-custom-white text-left font-bahnschrift flex gap-1 items-center">
									{showWalletAndBalance() ? (
										'R$ '
									) : choosePlatform() ? (
										<PickProIcon
											style="w-7 h-7"
											color="#ffffff"
										/>
									) : (
										<FutProIcon
											style="w-7 h-7"
											color="#ffffff"
										/>
									)}
									{CurrencyFormatter(
										Number(currentBalanceBonus)
									)}
								</p>
							</div>
						</div>
					</div>
				</div>
				<div className="flex flex-row gap-2 items-center justify-start ml-4 relative bottom-7">
					<button
						onClick={() => navigate('/wallet/deposit')}
						className="w-[67px] h-[60px] py-2.5 px-5 gap-1 flex flex-col items-center justify-center rounded-lg bg-custom-white shadow"
					>
						<Deposit2 />
						<p className="text-xs text-center text-custom-gray3 font-bahnschrift">
							Depositar
						</p>
					</button>
					<button
						onClick={() => navigate('/wallet/withdraw')}
						className="w-[67px] h-[60px] py-2.5 px-5 gap-1 flex flex-col items-center justify-center rounded-lg bg-custom-white shadow-md"
					>
						<Withdraw2 />
						<p className="text-xs text-center text-custom-gray3 font-bahnschrift">
							Sacar
						</p>
					</button>
				</div>

				<div className="flex flex-col pb-5 gap-3.5">
					<p className="text-xl font-semibold text-left text-custom-gray3 font-bahnschrift hidden lg:block">
						Transações
					</p>
					<TabsButton
						initialPage={'Disponível'}
						render={tabsData}
						onChangeTab={onChangeTabs}
					/>
				</div>
			</div>

			<Footer />
		</Layout>
	);
};
